<nb-card *ngIf="this.tonBlockchain.getBatchTransferIds().length > 0">
  <nb-card-header>
    برداشت گروهی
  </nb-card-header>
  <nb-card-body>
    <div class="d-flex mb-3 gap-3">
      <button (click)="openSeedDialog()" [nbSpinner]="sendTransactionLoading" [disabled]="sendTransactionLoading"
              nbButton status="primary">تایید {{ tonBlockchain.getBatchTransferIds().length }} برداشت بر روی شبکه تن
      </button>
      <button nbButton (click)="selectAllWithdraw()">انتخاب همه</button>
      <button nbButton (click)="deSelectAllWithdraw()">حذف همه</button>
      <input nbInput type="number" placeholder="تعداد برداشت" (input)="selectExactNumberOfWithdraw($event)">
    </div>
    <div class="d-flex flex-column">
      <strong class="block mb-3">جزییات برداشت</strong>
      <p>مجموع برداشت تن با کسر کارمزد: <strong>{{ this.getBatchTransferSumAmount('TON') }}</strong> تن</p>
      <p>مجموع برداشت نات با کسر کارمزد: <strong>{{ this.getBatchTransferSumAmount('NOT') }}</strong> نات</p>
      <p>مجموع برداشت تتر با کسر کارمزد: <strong>{{ this.getBatchTransferSumAmount('USDT') }}</strong> تتر</p>
      <p>مجموع برداشت داگز با کسر کارمزد: <strong>{{ this.getBatchTransferSumAmount('DOGS') }}</strong> داگز</p>
      <p>مجموع برداشت کتیزن با کسر کارمزد: <strong>{{ this.getBatchTransferSumAmount('CATI') }}</strong> کتیزن</p>
      <p>مجموع برداشت راکی‌بیت با کسر کارمزد: <strong>{{ this.getBatchTransferSumAmount('RBTC') }}</strong> راکی‌بیت</p>
      <p>مجموع برداشت همستر با کسر کارمزد: <strong>{{ this.getBatchTransferSumAmount('HMSTR') }}</strong> همستر</p>
      <p>مجموع برداشت همستر با کسر کارمزد: <strong>{{ this.getBatchTransferSumAmount('CATS') }}</strong>کتز</p>
      <p>مجموع برداشت همستر با کسر کارمزد: <strong>{{ this.getBatchTransferSumAmount('X') }}</strong>ایکس امپایر</p>
    </div>
  </nb-card-body>
</nb-card>
<nb-card>
  <nb-card-header>
    <div class="d-flex justify-content-between">
      <div class="d-flex">
        <i class="fal file-invoice-dollar ms-2"></i>
        درخواست‌های برداشت ارز
      </div>
      <div class="d-flex">
        <nb-toggle
          [checked]="!withdrawAlert.show"
          (checkedChange)="setWithdrawAlert({ show: !$event, silent: withdrawAlert.silent })"
          class="ms-3"
        >
          عدم نمایش اعلان
        </nb-toggle>
        <nb-toggle
          [checked]="withdrawAlert.silent"
          (checkedChange)="setWithdrawAlert({ show: withdrawAlert.show, silent: $event })"
        >
          بی صدا کردن اعلان
        </nb-toggle>
      </div>
    </div>
  </nb-card-header>
  <nb-card-body class="position-relative">
    <nb-tabset [tabIndex]="activeTab" (changeTab)="changeWithdrawList($event)">
      <nb-tab class="px-0" tabId="0" tabTitle="در انتظار بررسی">
        <ng-container [ngTemplateOutlet]="WithdrawList"
                      [ngTemplateOutletContext]="{limit:limitPending,type:'pending'}"></ng-container>
      </nb-tab>
      <nb-tab class="px-0" tabId="1" tabTitle="بررسی گردید">
        <ng-container [ngTemplateOutlet]="WithdrawList"
                      [ngTemplateOutletContext]="{limit:limitChecked,type:'checked'}"></ng-container>
      </nb-tab>
      <nb-tab class="px-0" tabId="2" tabTitle="برداشت‌های شبکه تن مقادیر کمتر یا مساوی ۳ تن">
        <ng-container [ngTemplateOutlet]="WithdrawList"
                      [ngTemplateOutletContext]="{limit:limitUnderXTon,type:'UnderXTonRequests'}"></ng-container>
      </nb-tab>
      <nb-tab class="px-0" tabId="3" tabTitle="برداشت‌های دارای فیلد پیغام (برداشت‌های پوچ شده)">
        <ng-container [ngTemplateOutlet]="WithdrawList"
                      [ngTemplateOutletContext]="{limit:limitUnderXTon,type:'HasMessageColumn'}"></ng-container>
      </nb-tab>
    </nb-tabset>
  </nb-card-body>
</nb-card>
<ng-template #WithdrawList let-limit="limit" let-type="type">
  <div class="d-none d-lg-flex align-items-center mb-2">
    <nb-select
      class="ms-2"
      [selected]="limit"
      (selectedChange)="changeRecordPerPageLimit($event,type)"
      placeholder="تعداد رکورد"
    >
      <nb-option [value]="10">10</nb-option>
      <nb-option [value]="15">15</nb-option>
      <nb-option [value]="25">25</nb-option>
      <nb-option [value]="50">50</nb-option>
      <nb-option [value]="100">100</nb-option>
    </nb-select>
  </div>
  <div class="table-responsive overflow-visible">
    <p-table
      [value]="withdraws"
      [tableStyleClass]="'table text-center table-striped  stacked-table table-hover'"
      [alwaysShowPaginator]="false"
      [autoLayout]="true"
      [paginator]="true"
      [rows]="limit"
      [totalRecords]="withdraws.length"
      [loading]="tableLoading"
      class="table table-bordered text-center"
    >

      <ng-template pTemplate="header">
        <tr style="height: 80px;">
          <th *ngIf="activeTab === '1' || activeTab === '2'">برداشت گروهی</th>
          <th>عملیات</th>
          <th>زمان</th>
          <th>تایید تماس تلفنی</th>
          <th>نام و نام‌خانوادگی</th>
          <th>ایمیل و شماره تلفن</th>
          <th>ارز</th>
          <th>شبکه</th>
          <th>تگ/ممو</th>
          <th>مبلغ</th>
          <th>کارمزد</th>
          <th>مبلغ با کسر کارمزد</th>
          <th>آدرس کیف پول</th>
          <th>وضعیت</th>
          <th>پیغام</th>
          <th>انتقال خودکار</th>
          <th>ذخیره</th>
          <th>معادل تتری</th>
          <th>معادل تومانی</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-withdraw>
        <tr>
          <td *ngIf="activeTab === '1' || activeTab === '2'">
            <nb-checkbox *ngIf="withdraw.currency.network === 'TON'" [checked]="tonBlockchain.idExistInsideList(withdraw.id)"
                         (checkedChange)="changeBatchTransferIdSelection($event,withdraw.id)"></nb-checkbox>
          </td>
          <td class="cursor-pointer" style="width: 60px">
            <i
              (click)="copyRow(withdraw, 'اطلاعات برداشت کپی شد.')"
              class="fa fa-copy fa-1x ms-3"
            ></i>
            <i (click)="openNote(withdraw.user.id)" class="fa fa-1x fa-sticky-note"></i>
          </td>
          <td>{{ withdraw.createdAt | dateFormat : 'jDD jMMMM - HH:mm' }}</td>
          <td>
              <span
                class="text-success"
                *ngIf="withdraw.user.settings | callOnWithdraw; else inactiveTemplate"
              >
                فعال
              </span>
            <ng-template #inactiveTemplate>
              <span class="text-danger">غیرفعال</span>
            </ng-template>
          </td>
          <td>
            <a class="text-primary" routerLink="/dashboard/user/{{ withdraw?.user?.id }}">
              {{ withdraw?.user?.firstName }} {{ withdraw?.user?.lastName }}
            </a>
          </td>
          <td>
            <span class="d-block mb-1">{{ withdraw?.user?.email ?? withdraw?.user?.phone }}</span>
          </td>
          <td class="text-danger">
            <strong>{{ withdraw?.currency?.name }}</strong>
          </td>
          <td class="text-danger">
            <strong>{{ withdraw?.currency?.network }}</strong>
          </td>
          <td class="qr-code-container" (mouseenter)="withdraw.shouldRenderMemoQrCode = true">
            <span class="code" style="font-weight:  bold;color:'#F3BA2F'">{{ withdraw.tag || '-' }}</span>
            <img class="memo-qr-code" *ngIf="withdraw.tag && withdraw.shouldRenderMemoQrCode"
                 src="{{withdraw.tag | toQrCode | async}}" alt="qrCode" />
          </td>
          <td dir="ltr">{{ withdraw.amount | number : '1.0-8' }}</td>
          <td>{{ withdraw.fee | number :'1.0-5' }}</td>
          <td class="text-danger">
            <strong>{{ withdraw.amount - withdraw.fee | number : '1.0-8' }}</strong>
          </td>
          <td class="code qr-code-container">
            <i
              (click)="copy(withdraw.wallet, 'آدرس کیف پول کپی شد.')"
              class="far fa-copy ms-2 align-middle cursor-pointer text-primary"
            ></i>
            <div class="d-inline-block" (mouseenter)="withdraw.shouldRenderQrCode = true">
              <span>{{ withdraw.wallet.substring(0, 6) }}</span>
              <i class="far fa-ellipsis-h mx-1 align-middle" style="opacity: 80%"></i>
              <span>
                  {{
                  withdraw.wallet
                    .substring(withdraw.wallet.length - 6, withdraw.wallet.length)
                    .trim()
                }}
                </span>
              <img class="wallet-qr-code" *ngIf="withdraw.shouldRenderQrCode"
                   src="{{withdraw.wallet | toQrCode | async}}" alt="qrCode" />
            </div>
          </td>
          <td>
            <nb-select
              [status]="
                  errors['status'] !== undefined && selectedWithdraw === withdraw
                    ? 'danger'
                    : 'basic'
                "
              [(selected)]="withdraw.status"
            >
              <nb-option [value]="'PENDING'">در حال بررسی</nb-option>
              <nb-option [value]="'PROCESSING'">در حال انجام</nb-option>
              <nb-option [value]="'DONE'">انجام شده</nb-option>
              <nb-option [value]="'CANCELED'">لغو شده</nb-option>
            </nb-select>
          </td>
          <td>
            <input
              [status]="
                  errors['message'] !== undefined && selectedWithdraw === withdraw
                    ? 'danger'
                    : 'basic'
                "
              nbInput
              name="description"
              [(ngModel)]="withdraw.message"
            />
          </td>
          <td>
            <div
              *ngIf="withdraw.currency.network === 'TRC20'; else Metamask"
              class="position-relative"
            >
              <button
                [nbSpinner]="tronLinkLoading"
                [disabled]="tronLinkLoading"
                (click)="sendUsingTronLink(withdraw)"
                nbButton
                status="info"
                class="mt-1"
              >
                ارسال با ترون لینک
              </button>
            </div>
            <ng-template #Metamask>
              <div *ngIf="checkIfEthCompatible(withdraw.currency.network);else TONWEB" class="position-relative">
                <button
                  (click)="sendUsingMetaMask(withdraw)"
                  nbButton
                  status="warning"
                  class="mt-1">ارسال با متامسک
                </button>
              </div>
            </ng-template>
            <ng-template #TONWEB>
              <div *ngIf="withdraw.currency.network === 'TON'; else empty" class="position-relative">
                <button
                  (click)="sendUsingTonkeeper(withdraw)"
                  nbButton
                  status="info"
                  class="mt-1">ارسال با TONKeeper
                </button>
              </div>
            </ng-template>
          </td>
          <td>
            <button
              [nbSpinner]="saveLoading && selectedWithdraw === withdraw"
              [disabled]="saveLoading && selectedWithdraw === withdraw"
              (click)="updateWithdraw(withdraw)"
              nbButton
              size="medium"
              status="success"
            >
              <i class="fas fa-save ms-1"></i>
              ذخیره
            </button>
          </td>
          <td>
            {{
              getCurrencyPrice(withdraw, 'USDT') | number:'1.0-2'
            }}
          </td>
          <td>
            {{
              getCurrencyPrice(withdraw, 'IRR') | number:'1.0-0'
            }}
          </td>
        </tr>
      </ng-template>
      <tbody>
    </p-table>
  </div>
  <div *ngIf="tableLoading" class="loading-backdrop">
    <i class="fal fa-circle-notch fa-spin fa-3x"></i>
  </div>
</ng-template>
<ng-template #empty>-</ng-template>
<ng-template #SeedPhraseTemplate let-ref="dialogRef">
  <nb-card style="min-width: 600px;">
    <nb-card-header>لطفا ۲۴ کلمه کیف پول را وارد نمایید</nb-card-header>
    <nb-card-body>
      <div class="mb-3">
        <nb-toggle [(checked)]="v5Wallet">ارسال با کیف پول ورژن ۵</nb-toggle>
      </div>
      <textarea class="w-100" style="max-width: 100%" nbInput rows="5" [ngModel]="seed"
                (ngModelChange)="getSeedPhrase($event,ref)"></textarea>
    </nb-card-body>
  </nb-card>
</ng-template>
